import React, { memo } from 'react';
import {useRef, useState} from 'react';
import { Handle } from 'react-flow-renderer';
// import data from './Data' ;

import plus from '../img/plus.png';
import minus from '../img/minus.png';
import task from '../img/task.png';
import SimpleTree from './SimpleTree'
import DesignCard from './DesignCard';

// import TaskIcon from '@material-ui/icons/AssignmentTwoTone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList } from '@fortawesome/free-solid-svg-icons'
import ListIcon from '@mui/icons-material/List';

import ReactFlow, {
  ReactFlowProvider,
  addEdge,
  removeElements,
  Controls, Background
} from 'react-flow-renderer';  


import BizNode from './BizNode';

export default memo(({ data }) => {
  const istyle = {
    width:200, 
    height:600,
  }
  const nodeTypes = {
    BizNode: BizNode,
  };
  
  const initialElements = [
    {
      id: '1',
      type: 'input',
      data: { label: 'Begin' },
      position: { x: 250, y: 30 },
      style: {
        background: 'beige',
        color: 'black',
        border: '1px solid #222138',
        width: 50,
      },
    },
    {
      id: '2',
      type: 'output',
      data: { label: 'End' },
      position: { x: 250, y: 500 },
      style: {
        background: 'beige',
        color: 'black',
        border: '1px solid #222138',
        width: 50,
      },



    },
    {
      id: 'edge-1-2',
      source: '1',
      target: '2',
      type: 'buttonedge',
    },

  ];
  const reactFlowWrapper = useRef(null);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);

  const [elements, setElements] = useState(initialElements);
  const onConnect = (params) => setElements((els) => addEdge(params, els));
  const onElementsRemove = (elementsToRemove) =>
    setElements((els) => removeElements(elementsToRemove, els));
        
    const [height, setHeight] = useState(150)
    var style = {
        background:'skyblue',
        color:'magenta',
        textAlign:'center',
        width:50,
        height:{height},
    
    
    } 
    const [mystate, setMyState] = useState(0)
    const[ exco, setIcon] = useState(plus)
    const  imageClick = () => {
        if (mystate == 0) {
            setIcon ( minus )
            setMyState(1)
            setHeight (600); 
        }
        else if (mystate == 1) {
            setMyState(0)
            setHeight (100); 
            setIcon ( plus )
        }
    }


    const renderContent = () => {
      return
      if (mystate == 0) {return}

      return (
  
        <ReactFlowProvider>
         {/* <SimpleTree data={data}></SimpleTree>  */}
        <div style={istyle} className="reactflow-wrapper" ref={reactFlowWrapper}>
                <ReactFlow
                    style={style}
                    elements={elements}
                    nodeTypes={nodeTypes}
                    onConnect={onConnect}
                    onElementsRemove={onElementsRemove}
                    // onLoad={onLoad}
                    // onDrop={onDrop}
                    // onDragOver={onDragOver}
                    // onElementClick={onElementClick}
                >
                    <Controls />
                    <Background variant="dots" color="gray" gap={10} /> 
  
                </ReactFlow>
  
            </div>
      </ReactFlowProvider>
  
  
  
      );

    }
    // var displayLabel= data.label + ":" + data.attributes["BizName"]
    const designerIconStyle = {
      // backgroundImage:'linear-gradient(to bottom, grey, royalblue)', color:'white', padding:'5px', borderRadius:'20px', marginLeft:'10px'
      padding:'0px', color:'royalblue', borderRadius:'20px', marginTop:'10px', marginLeft:'10px', marginRight:'10px'
    }
  
    return (
    <div className="designnode">
      <Handle
        type="target"
        position="top"
        // style={{ background: '#555' }}
        onConnect={(params) => console.log('handle onConnect', params)}
      />
        {/* <img src={exco} width='20' height='20' onClick={imageClick}></img> */}
        
        {/* <h3>Task:{data.label}  <img src={plus} width='20' height='20'></img></h3> */}
        {/* <img draggable={false} src={task} width='50' height='50' onClick={imageClick}></img> */}

        {/* <TaskIcon fontSize='large' style={designerIconStyle} draggable={false}/> */}
        {/* <FontAwesomeIcon icon={faList} style={designerIconStyle} size='2x'/> */}
        <ListIcon fontSize='medium' style={designerIconStyle} draggable={false}/>


        {/* {renderContent()} */}
        <DesignCard attributes={data.attributes} name={data.label}/>

      <Handle
        type="source"
        position="bottom"
        id="b2"
        style={{ bottom: -5, top: 'auto', background: '#555' }}
      />
    </div>
  );
});